module.exports = __webpack_public_path__ + "static/media/FAQ.89570fa8.md";